import { useContext, useEffect, useState } from 'react';

import MasterPlayerModalComponent from '@/components/master-player-modal';
import FantasyHistoricModalComponent from '@/components/master-player-modal/fantasy-historic-modal';
import { Context } from '@/context';

import ShowMarketProjectionComponent from '../../jugadores-v2/drawers/market-projection/ShowMarketProjection';

import MinutesActionsPlayerComponent from './minutes-actions-players';
import ModalActionsPlayer from './modal-actions-player';
import { Box } from '@mui/material';
import CalendarioDelJugadorDrawer from '../../jugadores-v2/drawers/calendario-jugador/CalendarioDelJugadorDrawer';
import JugadorLineupInformationModal from './JugadorLineupInformationModal';
import JugadorLineupAlineacionConfirmadaModal from './JugadorLineupAlineacionConfirmadaModal';

const MasterActionsPlayersComponent = () => {
    const { state, dispatch } = useContext(Context);
    const { playerProfile } = state;
    const { fantasyHistoric } = state;
    const { masterAccionesPlayerId } = state;
    const { marketProjection } = state;
    const { playerCalendar } = state;
    const { playerMinutes } = state;
    const { playerAlineacionProbable } = state;

    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (masterAccionesPlayerId > 0) {
            setOpen(true);
        }
    }, [masterAccionesPlayerId]);

    return (
        <Box className="master-actions-players">
            {open && <ModalActionsPlayer playerId={masterAccionesPlayerId} open={open} setOpen={setOpen} />}
            {(playerProfile?.playerId > 0 || playerProfile?.fantasyId > 0) && (
                <MasterPlayerModalComponent
                    playerId={playerProfile?.playerId}
                    fantasyId={playerProfile?.fantasyId}
                    dispatch={dispatch}
                />
            )}
            {(fantasyHistoric?.fantasyId > 0 || fantasyHistoric?.playerId > 0) && (
                <FantasyHistoricModalComponent
                    fantasyId={fantasyHistoric?.fantasyId}
                    playerId={fantasyHistoric?.playerId}
                    season={fantasyHistoric?.season}
                    mode={fantasyHistoric?.mode}
                    dispatch={dispatch}
                />
            )}
            {marketProjection > 0 && (
                <ShowMarketProjectionComponent marketProjection={marketProjection} dispatch={dispatch} />
            )}
            {playerCalendar > 0 && (
                <CalendarioDelJugadorDrawer playerCalendar={playerCalendar} dispatch={dispatch} />
            )}
            {playerMinutes > 0 && (
                <MinutesActionsPlayerComponent playerId={playerMinutes} dispatch={dispatch} />
            )}
            {playerAlineacionProbable?.id > 0 && playerAlineacionProbable?.lineupMode !== 'confirmed' && (
                <JugadorLineupInformationModal player={playerAlineacionProbable} open={true} />
            )}

            {playerAlineacionProbable?.id > 0 &&
                playerAlineacionProbable?.lineupMode === 'confirmed' &&
                playerAlineacionProbable?.estadisticas?.length > 0 && (
                    <JugadorLineupAlineacionConfirmadaModal player={playerAlineacionProbable} open={true} />
                )}
        </Box>
    );
};

export default MasterActionsPlayersComponent;
